import React from "react";
import { StyledTypography } from "./styles";

export const PageMarker = ({ page = 1, pages = 1 }) => {
  return (
    <StyledTypography variant="caption">
      {page} of {pages}
    </StyledTypography>
  );
};

export default PageMarker;
